import React, { useEffect, useState } from "react";
import { Grid, Button, Checkbox } from "@material-ui/core";
import Add from "@material-ui/icons/Add";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import './RequestSubTypeDocDetails.css';
import RequestSubType from "../../RequestSubType/RequestSubType";

const RequestSubTypeDocDetails = ({
  handleClose,
  handleSave,
  show,
  activeRequestList,
  isEdit,
  data,
  handleValidation
}) => {

  const defaultData = {
    requestSubTypeId: null,
    documentRankingId: null,    
    requestSubType: null,
    rank: null,
    category: null,
    documentName: "",
    documentDescription: "",
  };
  const errorData = {
    // Error fields
    documentDescriptionErr: "",
    documentNameErr: "",
    requestSubTypeIdErr: "",
    documentRankingIdErr: "",
    requestSubTypeErr: "",
    categoryErr: "",
  };
  const [errorFields, setErrorFields] = useState({ ...errorData });
  const [formData, setFormData] = useState({ ...defaultData });
  const [rankings, setRankings] = useState([]);
  const [loadingRanks, setLoadingRanks] = useState(false);
  const [subTypes, setSubTypes] = useState([]);
  useEffect(() => {
    if (show) {
      setLoadingRanks(true);
      axios.get(`${global.REACT_APP_API_ENDPOINT}/documentRanking/getAllDocumentRanking`)
      .then((response) => setRankings(response.data ?? [] ))
      .then( () => console.log("fetched rankings", rankings) )
      .finally( () => setLoadingRanks(false));

    }

      if (subTypes && subTypes.length === 0) {
        activeRequestList.forEach(r => {
          subTypes.push({ id: r.requestSubTypeId, name: r.requestSubTypeName });
        });
      }
    }
  , [show]);

  useEffect(() => {
    if (isEdit) {
      getRequestTypeDetails();
          } else {
      setFormData({ ...defaultData });
    }
    setErrorFields({ ...errorData });
  }, [show]);

  const getRequestTypeDetails = () => {
    // Prepopulate all fields from data, fallback to defaultData if missing
    setFormData({ ...defaultData, ...data });
  };

  const handleSubmit = async () => {
    let {user} = JSON.parse(sessionStorage.getItem("passData"));
    let errorFieldsData = { ...errorData };
    let validationError = false;

    if (!handleValidation(formData, errorFieldsData)) {
      validationError = true;
      console.log('Validation failed:', errorFieldsData);
    }

    if (!formData.documentDescription) {
      errorFieldsData.documentDescriptionErr = "This field is required";
      validationError = true;
    }
    if (!formData.documentName) {
      errorFieldsData.documentNameErr = "This field is required";
      validationError = true;
    }
    if (!formData.rank) {
      errorFieldsData.rankErr = "Document Rank is required";
      validationError = true;
    }
    if (!formData.category) {
      errorFieldsData.categoryErr = "Category is required";
      validationError = true;
    }
    setFormData({ ...formData });
    setErrorFields({ ...errorFieldsData });
    if (validationError) {
      return;
    }
    if (!formData.createdBy) {
      formData.createdBy = user;
    }
    if (isEdit) {
      await axios.post(
        `${global.REACT_APP_API_ENDPOINT}/requestType/updateRequestSubTypeDoc`, { ...formData, updatedBy: user });
      // Update ranking
      await updateDocumentRanking(formData.documentRankingId, {
        documentRankingId: formData.documentRankingId,
        documentName: formData.documentName,
        documentDescription: formData.documentDescription,
        rank: formData.rank,
        category: formData.category,
        createdDate: formData.createdDate ? formData.createdDate : Date.now(),
        createdBy: formData.createdBy || user,
        updatedDate: Date.now(),
        updatedBy: user
      });
      handleSave();
    } else {
      //create ranking
      await createDocumentRanking({
        documentName: formData.documentName,
        documentDescription: formData.documentDescription,
        rank: formData.rank,
        category: formData.category,
        createdDate: Date.now(),
        createdBy: user,
        updatedDate: Date.now(),
        updatedBy: user
      });
      handleSave();
    }
  };

  const handleChange = (event) => {
    console.log("event",event)
    if (event.target.value == "") {
      errorFields[event.target.name + "Err"] = "This field is required"
    }
    else {
      errorFields[event.target.name + "Err"] = "";
    }
    setFormData({
      ...formData,
      [event.target.name]: event.target.value,
    });
    setErrorFields({
      ...errorFields,
    })
  };

  // Remove duplicate subtypes by name
  const uniqueSubTypes = Array.from(new Map(subTypes.map(st => [st.name, st])).values());

  // Remove duplicate categories from rankings
  const uniqueCategories = Array.from(new Set(rankings.map(r => r.category || r.rank)));

  const resetForm = () => {
    setFormData({ ...defaultData });
    setErrorFields({ ...errorData });
  };

  const handleModalClose = () => {
    resetForm();
    handleClose();
  };

  useEffect(() => {
    if (!show) {
      resetForm();
    }
  }, [show]);

  // Helper to create a new document ranking
  const createDocumentRanking = async (rankingData) => {
    return axios.post(`${global.REACT_APP_API_ENDPOINT}/documentRanking`, rankingData);
  };

  // Helper to update an existing document ranking
  const updateDocumentRanking = async (id, rankingData) => {
    return axios.put(`${global.REACT_APP_API_ENDPOINT}/documentRanking/${id}`, rankingData);
  };

  return (
    <Modal
      show={show}
      size="lg"
      backdrop="static"
      style={{
        background: "rgba(0, 0, 0, 0.5)",
      }}
      onHide={handleModalClose}
    >
      <Modal.Header className="the-modal-header" closeButton>
        {!isEdit ? (<Add
          style={{
            color: "#000000",
            marginRight: "5px",
            height: "25px",
            width: "25px",
          }}
        />) : (<></>)}
        <Modal.Title className="the-modal-title">
          {isEdit ? "Update Document" : "Add Document"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="request-modal-body">
        <Grid container spacing={2}>
                    <Grid item container spacing={2} xs={12} sm={12} md={6} className="request-input-group">
            <Grid item xs={12} sm={12} md={12}>
              <div>Document Name*</div>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <input
                type="text"
                id="documentName"
                name="documentName"
                className="form-control"
                value={formData.documentName}
                onChange={(event) => {
                  handleChange(event);
                }}
              />
              {errorFields.documentNameErr != "" ? (
                <p style={{ color: "red", margin: "0px" }}>{errorFields.documentNameErr}</p>
              ) : <></>}
            </Grid>
          </Grid>
        </Grid>

        <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={12}>
              <div>Document Desc*</div>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
              <textarea
                type="text"
                id="documentDescription"
                name="documentDescription"
                className="form-control"
                value={formData.documentDescription}
                onChange={(event) => {
                  handleChange(event);
                }}
              />
              {errorFields.documentDescriptionErr != "" ? (
                <p style={{ color: "red", margin: "0px" }}>{errorFields.documentDescriptionErr}</p>
              ) : <></>}
            </Grid>
          </Grid>
          <Grid container spacing={2}>
          <Grid item container spacing={2} xs={12} sm={12} md={10} className="request-input-group">
            <Grid item xs={12} sm={12} md={12}>
              <div>Document Rank*</div>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <input
                type="number"
                id="documentRank"
                name="rank"
                className="form-control"
                value={formData.rank == null ? "" : formData.rank}
                onChange={(event) => {
                  handleChange(event);
                }}
              />
              {errorFields.rankErr != "" ? (
                <p style={{ color: "red", margin: "0px" }}>{errorFields.rankErr}</p>
              ) : <></>}
            </Grid>
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item container spacing={2} xs={12} sm={12} md={10} className="request-input-group">
            <Grid item xs={12} sm={12} md={12}>
              <div>Category*</div>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <select
                required
                id="category"
                name="category"
                className="form-control"
                value={formData.customCategoryMode ? "Custom" : (formData.category || "")}
                onChange={event => {
                  handleChange(event);
                  if (event.target.value === "__custom__") {
                    setFormData({ ...formData, category: "Custom", customCategoryMode: true });
                  } else {
                    setFormData({ ...formData, category: event.target.value, customCategoryMode: false });
                  }
                  setErrorFields({ ...errorFields });
                }}
              >
                {formData.customCategoryMode
                  ? <option value="Custom">Custom</option>
                  : <option value="">Select one</option>
                }
                {uniqueCategories.map((cat, idx) => (
                  <option key={cat + '-' + idx} value={cat}>{cat}</option>
                ))}
                <option value="__custom__" style={{ fontWeight: 'bold', background: '#e3f2fd', border: '1px solid #1176B5' }}>
                  <span style={{ display: 'block', padding: '6px 0', fontWeight: 'bold', color: '#1176B5' }}>Custom...</span>
                </option>
              </select>
              {formData.customCategoryMode && (
                <div style={{ border: '2px solid #1176B5', borderRadius: '8px', background: '#f7fafd', padding: '12px', marginTop: '8px' }}>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter custom category"
                    value={formData.category === "Custom" ? "" : formData.category}
                    onChange={e => setFormData({ ...formData, category: e.target.value })}
                    required
                  />
                </div>
              )}
              {errorFields.categoryErr !== "" && (
                <p style={{ color: "red", margin: "0px" }}>{errorFields.categoryErr}</p>
              )}
            </Grid>
          </Grid>
        </Grid>
        
      </Modal.Body>
      <Modal.Footer className="the-modal-footer">
        <Button variant="contained" onClick={handleModalClose}>
          Cancel
        </Button>
        <Button variant="contained" style={{
          backgroundColor: "rgb(17, 118, 181)",
          textTransform: "none"
        }}
          color="primary" onClick={handleSubmit}>
          {isEdit ? "Update" : "Save"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RequestSubTypeDocDetails;
